module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#women-home",
      toString: function () {
        return this.url;
      }
    }